import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useClientAuth } from '../../contexts/ClientAuthContext';

const ClientProtectedRoute = () => {
  const { token, loading } = useClientAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!token) {
    return <Navigate to="/client-portal/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ClientProtectedRoute;
